import type { SelectionCardProps } from '@graftcode/design-system'

import { METHOD_TYPE_BADGE_LABELS } from '@/core/const/methodTypeBadgeLabels.const'
import { SELECTION_CARD_TITLE_WITH_BADGE_CLASS } from '@/core/const/selectionCardClasses.const'
import { useNavigationStore } from '@/core/stores/navigationStore'
import type { NavigationData } from '@/core/types/cardNavigation.type'
import type { LibraryData } from '@/core/types/library.type'
import { buildBreadcrumbs } from '@/core/utils/buildBreadcrumbs'
import { createTitleWithBadge } from '@/core/utils/createTitleWithBadge'
import { getRuntimeIcon } from '@/core/utils/tree/getRuntimeIcon'

import { EMPTY_NAVIGATION } from './emptyNavigation'

export const getLibraryNavigation = (
  library: LibraryData,
  libraryName: string,
  gateway: string,
  projectName?: string
): NavigationData => {
  if (!library?.classes) return EMPTY_NAVIGATION

  const classesCount = Object.values(library.classes).length

  return {
    list: Object.entries(library.classes).map(([classKey, classData]): SelectionCardProps & { id: string } => ({
      id: classKey,
      className: SELECTION_CARD_TITLE_WITH_BADGE_CLASS,
      header: createTitleWithBadge(classData.name, METHOD_TYPE_BADGE_LABELS.CLASS),
      children: '',
      showArrow: true,
      icon: getRuntimeIcon(library.runtimeName),
      onClick: () => useNavigationStore.getState().navigateTo([libraryName, classKey]),
    })),
    details: [],
    breadcrumbs: buildBreadcrumbs(gateway, libraryName, undefined, undefined, classesCount, projectName, library.name),
    libraryData: library,
    classData: undefined,
  }
}
